import logo from "../assets/WhatsApp-Image-2026-05-03-at-17.16.41.jpeg";

// ─── الـ CSS الخاص بشكل الطباعة (نسخة واحدة بس، مستخدمة من كل مكان) ──────────
export const PRINT_STYLES = `
  body{margin:0;padding:20px;font-family:Arial,sans-serif;direction:rtl;position:relative;box-sizing:border-box;}
  .cardmobile{display:none!important;}
  h2{text-align:center;font-size:20px;margin-bottom:10px;}
  h1{text-align:center;font-size:22px;margin-bottom:30px;}
  .platform-card{border:none!important;border-radius:6px;background:#fff!important;padding:20px;margin:0 auto 30px auto!important;width:100%!important;max-width:700px;page-break-inside:avoid;}
  .platform-card .card-logo{display:block;margin:0 auto 15px auto;width:60px!important;height:60px!important;object-fit:contain;}
  .platform-card h1{text-align:center;font-size:18px;margin:10px 0 20px 0;}
  .cards_number{display:grid!important;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:20px;}
  .card_number{border:1px solid #ccc;border-radius:4px;padding:8px;text-align:center;}
  .card_number img{width:18px!important;height:18px!important;margin-bottom:4px;object-fit:contain;}
  .card_number h6{font-size:12px;margin:0 0 4px 0;}
  .card_number p{font-size:14px;font-weight:bold;margin:0;}
  .big_table{width:100%;border-collapse:collapse;margin-top:10px;font-size:12px;}
  .big_table th,.big_table td{border:1px solid #333;padding:6px;text-align:center;}
  .big_table th{background:#eee;}
  .report-date{text-align:left;margin-top:40px;font-size:14px;color:#333;}
  .footer-text{text-align:center;font-size:14px;margin-top:30px;font-weight:bold;}
  .navlogo{display:flex;align-items:center;flex-direction:row-reverse;gap:20px;}
  .navlogo img{width:100px;}
  .all{display:flex;align-items:center;justify-content:center;flex-direction:column;gap:20px;margin-bottom:30px;}
  .report-section-card{border:1px solid #ddd;border-radius:8px;padding:16px;margin-bottom:16px;}
  .report-section-img{width:100%;max-height:200px;object-fit:cover;border-radius:6px;margin-bottom:8px;}
  .updates-table{width:100%;border-collapse:collapse;margin-top:10px;font-size:12px;}
  .updates-table th,.updates-table td{border:1px solid #333;padding:6px;text-align:center;}
  .updates-table th{background:#eee;}
  .updates-timeline{display:none;}
  @page{size:A4;margin:15mm;}
`;

const printHeader = (nameb) => `
  <div class="all">
    <h2>${nameb}</h2>
    <div class="navlogo">
      <h1>Golden Section</h1>
      <img src="${logo}" alt="" />
    </div>
  </div>
`;

const printFooter = () => `
  <div class="report-date">التاريخ: ${new Date().toLocaleDateString("ar-EG")}</div>
  <div class="footer-text">مع تحيات شركة جولدن سيكشن</div>
  <script>window.onload=function(){window.print();window.close();}</script>
`;

/**
 * يفتح نافذة الطباعة (desktop) ولو الـ popup اتبلوك (بيحصل كتير في الموبايل)
 * بيستخدم iframe مخفي بديل. نفس الدالة تتنادى من الديسكتوب والموبايل.
 */
export const openPrint = (title, bodyHtml, nameb) => {
  const html = `<html lang="ar" dir="rtl"><head><meta charset="UTF-8"/><title>${title}</title><style>${PRINT_STYLES}</style></head><body>${printHeader(nameb)}${bodyHtml}${printFooter()}</body></html>`;

  const win = window.open("", "_blank", "width=900,height=650");
  if (win && win.document) {
    win.document.open();
    win.document.write(html);
    win.document.close();
    return;
  }

  const existing = document.getElementById("__print_frame__");
  if (existing) existing.remove();
  const iframe = document.createElement("iframe");
  iframe.id = "__print_frame__";
  iframe.style.cssText =
    "position:fixed;width:0;height:0;border:none;left:-9999px;top:-9999px;";
  document.body.appendChild(iframe);
  iframe.contentWindow.document.open();
  iframe.contentWindow.document.write(html);
  iframe.contentWindow.document.close();
  iframe.contentWindow.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };
};
